export default __webpack_public_path__ + "static/media/Oro.14c944b0.png";